import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { from, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import Project from '../interfaces/Project';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  projects$ = new BehaviorSubject([]);
  
  constructor(private afs: AngularFirestore) {}

  getProjects() {
    const projectsRef: AngularFirestoreCollection<any> = this.afs.collection('projects');
    return from(projectsRef.valueChanges());
  }
  getAllProjects (limit = 10000) {
    const projectsRef: AngularFirestoreCollection<any> = this.afs.collection('projects', (ref) =>
      ref.orderBy('timestamp', 'desc').limit(limit)
    );
    return projectsRef.get().pipe(
      map((r) => {
        return r.docs.map((doc) => {
          return doc.data();
        });
      })
    );
  }
  getCurrentProject(id) {
    const projectRef: AngularFirestoreCollection<any> = this.afs.collection('projects', ref => ref.where('id', '==', id))
    return from(projectRef.valueChanges());
  }

  getCurrentUserOwnedProjects(uid) {
    const userProjectsRef: AngularFirestoreCollection<any> = this.afs.collection('projects', ref => ref.where('owner', '==', uid))
    return from(userProjectsRef.valueChanges());
  }

  getCurrentUserProjects(userProjects) {
    let projects = []
    if (userProjects && userProjects.length) {
      userProjects.forEach(up => {
        const userProjectsRef: AngularFirestoreCollection<any> = this.afs.collection('projects', ref => ref.where('id', '==', up))
        projects.push(from(userProjectsRef.valueChanges()))
      })
    }
    this.projects$.next(projects);
    return this.projects$;
  }

  getProjectMembers(id) {
    const membersRef: AngularFirestoreCollection<any> = this.afs.collection('users', ref => ref.where('projects', 'array-contains', id))
    return from(membersRef.valueChanges());
  }

  createProject(projectData) {
    return new Promise((resolve, reject) => {
      this.afs.collection('projects').add(projectData).then((dRef) => {
        dRef.update({ id: dRef.id }).then(() => {
          resolve(dRef.id);
        });
      });
    })
  }

  updateProject(projectId, d) {
    const projectRef: AngularFirestoreDocument<any> = this.afs.doc(`projects/${projectId}`);
    return projectRef.update(d);
  }

  deleteProject(projectId) {
    const projectRef: AngularFirestoreDocument<any> = this.afs.doc(`projects/${projectId}`);
    return projectRef.delete();
  }
}
